// A4 dimensions in millimeters
export const A4_WIDTH_MM = 210;
export const A4_HEIGHT_MM = 297;
export const A4_MARGIN_MM = 20;

// A4 dimensions in pixels (96 DPI: 1mm = 96/25.4 = 3.779527559px)
export const A4_WIDTH_PX = 794;
export const A4_HEIGHT_PX = 1123;
/** PDFViewer default height: one A4 page + ~toolbar (react-pdf embedded UI) */
export const A4_PDF_VIEWER_HEIGHT_PX = A4_HEIGHT_PX + 56;
export const A4_MARGIN_PX = 36; // 20mm

// Content area (A4 - margins)
export const A4_CONTENT_WIDTH_MM = 170; // 210 - 40
export const A4_CONTENT_HEIGHT_MM = 257; // 297 - 40
export const A4_CONTENT_WIDTH_PX = 643; // 794 - 152
export const A4_CONTENT_HEIGHT_PX = 972; // 1123 - 152

// Header / Body / Footer layout
export const A4_HEADER_HEIGHT_MM = 25;
export const A4_HEADER_HEIGHT_PX = 94; // 25mm
export const A4_FOOTER_HEIGHT_MM = 15;
export const A4_FOOTER_HEIGHT_PX = 57; // 15mm
export const A4_BODY_HEIGHT_MM = 217; // 257 - 25 - 15
export const A4_BODY_HEIGHT_PX = 819; // 972 - 94 - 57
